import React from 'react';

import { Fabric } from 'office-ui-fabric-react/lib/Fabric';
import {
  DetailsList,
  DetailsListLayoutMode,
  SelectionMode
} from 'office-ui-fabric-react/lib/DetailsList';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { Icon } from 'office-ui-fabric-react/lib/Icon';

import Cookies from "universal-cookie";

import HttpService from '../service/HttpService';
import Header from '../component/Header';

export default class Clients extends React.Component {
  http = new HttpService();
  loader = null;
  lo = require( 'lodash' );
  toPost = {};
  
  constructor( props ) {
    super( props );

    let cookies = new Cookies();
    let session = cookies.get( 'session' );

    if( !session ) {
      window.location.href = '/auth';
      return;
    }

    this.state = {
      viewOpen: false,
      showPanel: false,
      activeItem: {},
      items: []
    };
  }

  componentDidMount() {
    let loader = this.refs.header.loader().loading( 'Cargando clientes...' );
    
    this.http
      .getClients()
      .then( clients => {
        this.setState({ items: clients });

        loader.finish();
      })
      .catch( this.errorHandler );
  }

  errorHandler = ( error ) => {
    this.refs.header.dialog().show( error );
  }

  selectedItemChange = ( item ) => {
    this.setState({
      viewOpen: item
    });
  }

  newItemHandler = () => {
    this.setState({
      showPanel: true,
      activeItem: { }
    })
  }

  editItemHandler = () => {
    if( this.state.viewOpen !== false ) {
      this.setState({
        showPanel: true,
        activeItem: this.state.viewOpen
      })

      this.toPost = this.lo.cloneDeep( this.state.viewOpen );
    } else {
      this.setState({ activeItem: {} });

      this.errorHandler( 'Debe seleccionar un cliente para editar' );
    }
  }

  deleteItemHandler = () => {
    if( this.state.viewOpen !== false ) {

      let loader = this.refs.header.loader().loading( 'Guardando cambios...' );
      
      this.http
        .deleteClient( this.state.viewOpen.id )
        .then( ( clients ) => {
          this.toPost = null;

          this.setState({ items: clients, activeItem: {}, viewOpen: false });

          loader.finish();
        })
    } else {
      this.errorHandler( 'Debe seleccionar un cliente para eliminar' );
    }
  }

  saveItemHandler = () => {
    let loader = this.refs.header.loader().loading( 'Guardando cambios...' );

    this.http
      .saveClient( this.toPost )
      .then( ( clients ) => {
        this.toPost = null;

        this.setState({ items: clients, activeItem: {}, viewOpen: false });
        
        loader.finish();
      })
      .catch( this.errorHandler );

    this.setState({ showPanel: false });
  }

  showPolicies = () => {
    if( this.state.viewOpen !== false ) {
      document.location.href = '/policies/' + this.state.viewOpen.id;
    } else {
      this.errorHandler( 'Debe seleccionar un cliente para ver las pólizas asociadas' );
    }
  }

  showSinesters = () => {
    if( this.state.viewOpen !== false ) {
      document.location.href = '/sinesters/' + this.state.viewOpen.id;
    } else {
      this.errorHandler( 'Debe seleccionar un cliente para ver los siniestros asociados' );
    }
  }

  export = () => {
    console.log( this.state.items );
    
    let exportData = [ '#', 'Nombre', 'Teléfono', 'Email', 'DNI / CUIT', 'Fecha de Nacimiento', 'Calle', 'Número', 'Código Postal', 'Ciudad', 'Provincia'  ].join( ',' ) + '\r\n';

    this.state.items.forEach( ( item, index ) => {
      let row = [ item.id, item.name, item.phone, item.email, item.documentNumber, item.bornDate, item.addressStreet, item.addressNumber, item.addressZipcode, item.addressCity, item.addressState ];

      exportData = exportData + row.join( ',' ) + '\r\n';
    });

    var hiddenElement = document.createElement('a');
    hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI( exportData );
    hiddenElement.target = '_blank';
    hiddenElement.download = 'report.csv';
    hiddenElement.click();
  }

  updateItem = ( item ) => {
    this.toPost[item.target.name] = item.target.value;
  }
  
  render() {
    const items = this.state.items;
    const columns = [
      {
        key: 'column2',
        name: 'Nombre o Razón Social',
        fieldName: 'name',
        minWidth: 210,
        maxWidth: 350,
        isRowHeader: true,
        isResizable: true,
        isSorted: true,
        isSortedDescending: false,
        data: 'string',
        isPadded: true
      },
      {
        key: 'column3',
        name: 'DNI o CUIT',
        fieldName: 'documentNumber',
        minWidth: 100,
        maxWidth: 150,
        isResizable: true,
        data: 'string',
        isPadded: true
      },
      {
        key: 'column4',
        name: 'Teléfono',
        fieldName: 'phone',
        minWidth: 80,
        maxWidth: 120,
        isResizable: true,
        isCollapsable: true,
        data: 'string',
        isPadded: true
      },
      {
        key: 'column5',
        name: 'Email',
        fieldName: 'email',
        minWidth: 150,
        maxWidth: 300,
        isResizable: true,
        isCollapsable: true,
        data: 'string',
        isPadded: true 
      }
    ]

    const menuItems = [
      {
        key: 'new',
        text: 'Nuevo',
        iconProps: {
          iconName: 'Add'
        },
        onClick: this.newItemHandler
      },
      {
        key: 'edit',
        text: 'Editar',
        iconProps: {
          iconName: 'Edit'
        },
        onClick: this.editItemHandler
      },
      {
        key: 'delete',
        text: 'Eliminar',
        iconProps: {
          iconName: 'Delete'
        },
        onClick: this.deleteItemHandler
      },
      {
        key: 'policies',
        text: 'Pólizas',
        iconProps: {
          iconName: 'View'
        },
        onClick: this.showPolicies
      },
      {
        key: 'sinester',
        text: 'Siniestros',
        iconProps: {
          iconName: 'View'
        },
        onClick: this.showSinesters
      }
    ];
    const menuFarItems = [
      {
        key: 'info',
        iconOnly: true,
        name: 'Acerca de esta pantalla',
        iconProps: {
          iconName: 'Info'
        }
      }
    ];
    const customItems = [
      {
        key: 'export',
        text: 'Exportar',
        iconProps: {
          iconName: 'ExcelLogo'
        },
        onClick: this.export
      }
    ];

    return (
      <Fabric>
        <Header title="Clientes" ref="header" />

        <div className="ms-Grid">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-lg12" style={{ margin: 0, padding: 0 }}>
              <CommandBar
                  items={ menuItems }
                  overflowItems={ customItems }
                  farItems={ menuFarItems }
                />
            </div>
          </div>
          <div className="ms-Grid-row">
            <div className={ "ms-Grid-col ms-sm12 " + ( this.state.viewOpen ? 'ms-lg9' : 'ms-lg12' ) } style={{ borderRight: '1px solid #ccc', paddingTop: 20 }}> 
              <DetailsList
                items={ items }
                columns={ columns }
                selectionMode={ SelectionMode.none }
                setKey="set"
                layoutMode={ DetailsListLayoutMode.justified } 
                onActiveItemChanged={ this.selectedItemChange } />
            </div>
            <div className="ms-Grid-col ms-sm12 ms-lg3 ms-font-m" style={{ paddingTop: 20, display: this.state.viewOpen ? 'block' : 'none' }}>
              <div style={{ textAlign: 'right' }}><Icon iconName="ChromeClose" style={{ cursor: 'pointer' }} onClick={ () => { this.setState( { viewOpen: false, activeItem: {} } ); } }/></div>
              <h3 className="ms-font-xl">{ this.state.viewOpen.name } ({ this.state.viewOpen.documentNumber })</h3>
              <hr />
              <p><strong className="ms-fontWeight-semibold">Email</strong>: { this.state.viewOpen.email }</p>
              <p><strong className="ms-fontWeight-semibold">Teléfono</strong>: { this.state.viewOpen.phone }</p>
              <p><strong className="ms-fontWeight-semibold">Dirección</strong>: <br/>
                { this.state.viewOpen.addressStreet } { this.state.viewOpen.addressNumber } <br/>
                { this.state.viewOpen.addressZipcode } { this.state.viewOpen.addressCity } <br/>
                { this.state.viewOpen.addressState }
              </p>
            </div>
          </div>

          <Panel
            isOpen={this.state.showPanel}
            type={PanelType.smallFluid}
            onDismiss={ () => this.setState({ showPanel: false }) }
            headerText="Cliente"
            onRenderFooter={ () => {
              return (
                <div className="ms-textAlignCenter">
                <PrimaryButton onClick={ this.saveItemHandler } style={{ marginRight: 10 }}>Guardar</PrimaryButton>
                <DefaultButton onClick={ () => this.setState({ showPanel: false }) } >Cancelar</DefaultButton>
              </div>

              )
            }}>
              <div className="ms-Grid">
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm12 ms-lg6">
                    <TextField name="name" label="Nombre y Apellido o Razón Social" value={ this.state.activeItem.name } onChange={ this.updateItem }/>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg6">
                    <TextField name="documentNumber" label="DNI o CUIT" value={ this.state.activeItem.documentNumber } onChange={ this.updateItem }/>
                  </div>
                </div>
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm12 ms-lg6">
                    <TextField name="phone" label="Teléfono" value={ this.state.activeItem.phone } onChange={ this.updateItem }/>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg6">
                    <TextField name="email" label="Email" value={ this.state.activeItem.email } onChange={ this.updateItem }/>
                  </div>
                </div>
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm12 ms-lg4">
                    <TextField name="addressStreet" label="Calle" value={ this.state.activeItem.addressStreet } onChange={ this.updateItem }/>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg4">
                    <TextField name="addressNumber" label="Número" value={ this.state.activeItem.addressNumber } onChange={ this.updateItem }/>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg4">
                    <TextField name="addressCity" label="Ciudad" value={ this.state.activeItem.addressCity } onChange={ this.updateItem }/>
                  </div>
                </div>
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm12 ms-lg2">
                    <TextField name="addressZipcode" label="Código Postal" value={ this.state.activeItem.addressZipcode } onChange={ this.updateItem }/>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg10">
                    <TextField name="addressState" label="Provincia" value={ this.state.activeItem.addressState } onChange={ this.updateItem }/>
                  </div>
                </div>
              </div>

          </Panel>

        </div>
      </Fabric>
    );
  }
}


// WEBPACK FOOTER //
// ./src/screen/Clients.jsx